module.exports = __webpack_public_path__ + "static/media/order-confirmation-tick.214ae3b0.png";